import Vue from 'vue'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

const state = {
  // form
  targetId: Constants.RegisterHash,
  values: {},

  // model
  tenantModel: [],
  communityModel: []
}

const getters = {
  get: state => state,
  
  // 登録値を表示用に変換
  getValue: state => (key) => {
    try {
      let value = state.values[key]
      switch (key) {
        default:
          return value
      }
    /* eslint-disable no-new */
    } catch (e) {
      return ''
    }
  }
}

const actions = {
  /**
   * 初期読出し
   */
  loadModel ({commit}, {targetId, tenantParams}) {
    commit('setTargetId', targetId)

    return new Promise((resolve, reject) => {
      // データを読出し
      ApiManager.request(
        ['tenant'],
        ['v1TenantListGet'],
        [tenantParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('inited')
            commit('setTenantModel', res[0].data.tenants)
            console.log('tenantModel', state.tenantModel)
            resolve(res[0].data)

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          reject(null)
        })
    })
  },
  /**
   * コミュニティ一覧読み出し
   */
  loadCommunityModel ({commit}, {communityParams}) {
    return new Promise((resolve, reject) => {
      // データを読出し
      ApiManager.request(
        ['community'],
        ['v1CommunityListGet'],
        [communityParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setCommunityModel', res[0].data.communities)
            console.log('communityModel', state.communityModel)
            resolve(res[0].data)

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          reject(null)
        })
    })
  },
  
  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
  // init
  inited (state) {
    Vue.set(state.values, 'inpServiceName', null)
    Vue.set(state.values, 'inpTenant', '')
    Vue.set(state.values, 'inpCommunity', '')
  },

  // model
  setTenantModel (state, data) {
    // data.sort(Utility.sortByKey('CreatedAt', false))
    Vue.set(state, 'tenantModel', data)
  },
  setCommunityModel (state, data) {
    // data.sort(Utility.sortByKey('CreatedAt', false))
    Vue.set(state, 'communityModel', data)
  },

  // form
  setTargetId (state, targetId) {
    state.targetId = targetId
  },
  setValues (state, values) {
    Vue.set(state, 'values', values)
  },
  setInputValue (state, {key, value}) {
    Vue.set(state.values, key, value)
  },

  // reset
  reset (state) {
    state.targetId = Constants.RegisterHash
    Vue.set(state, 'values', {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
